import { render } from "./index.vue?vue&type=template&id=ef4c9f00&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ef4c9f00&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4c9f00"],['__file',"src/views/DashboardGestor/components/DashboardGestorTime/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef4c9f00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef4c9f00', __exports__)) {
    console.log('reload')
    api.reload('ef4c9f00', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ef4c9f00&scoped=true", () => {
    console.log('re-render')
    api.rerender('ef4c9f00', render)
  })

}


export default __exports__